import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    // We will add original data later
};

const featuresSlice = createSlice({
    name: 'features',
    initialState,
    reducers: {
        // We will add reducers later
    },
});

export default featuresSlice.reducer;
